var map = {
	"./china.png": 402,
	"./euro.png": 403,
	"./germany.png": 404,
	"./hong kong.png": 405,
	"./japan.png": 406,
	"./singapore.png": 407,
	"./taiwan.png": 408,
	"./united kingdom.png": 409,
	"./united states.png": 410
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 401;